// extracted by mini-css-extract-plugin
export default {"threadsContainer":"PortalCommunicationsThreadsViewComponent_threadsContainer__LSqEi"};